import { FC, useEffect, useState } from 'react';
import './UmbsInventory.css';
import eFormType from '../../../main/assets/enums/eFormType';
import { useForm } from 'react-hook-form';
import GeneralInput from '../../../main/components/generalInput/GeneralInput';
import React from 'react';
import IUMB from '../../../main/interfaces/IUMB';
import IRow from '../../../main/interfaces/IRow';
import IArea from '../../../main/interfaces/IArea';
import { ApiConstants } from '../../../main/constants/ApiConstants';
import { toast } from 'react-toastify';
import axiosInstance from '../../../main/initializers/axios';
import GeneralSelect from '../../../main/components/select/GeneralSelect';
import { useTranslation } from 'react-i18next';

interface Props {
  tempProduct?: any;
  rows?: IRow[];
  areas?: IArea[];
  modalType: eFormType;
  onSubmitData: () => void;
  createOrUpdate: boolean;
}

const UmbsInventory: FC<Props> = (props: Props) => {
  const { tempProduct, rows, areas, modalType, createOrUpdate } = props;

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<IUMB>({
    defaultValues: {
      id: modalType === eFormType.Edit ? tempProduct?.id : 0,
      code: modalType === eFormType.Edit ? tempProduct?.code : '',
      name: modalType === eFormType.Edit ? tempProduct?.name : '',
      firstPrice: modalType === eFormType.Edit ? tempProduct?.firstPrice : 0,
      secondPrice: modalType === eFormType.Edit ? tempProduct?.secondPrice : 0,
      secondPriceTime: modalType === eFormType.Edit ? tempProduct?.secondPriceTime : null,
      isBusy: modalType === eFormType.Edit ? tempProduct?.isBusy : false,
      rowId: modalType === eFormType.Edit ? tempProduct?.rowId : null,
      areaId: modalType === eFormType.Edit ? tempProduct?.areaId : null,
    },
  });

  const [updateAll, setUpdateAll] = useState(false);
  const [dateSelected, setDateSelected] = useState(tempProduct?.secondPriceTime);

  const { i18n } = useTranslation();

  const onSubmit = async (data: any) => {
    const params = {
      id: data.id,
      code: data.code,
      name: data.name,
      firstPrice: Number(data.firstPrice),
      secondPrice: Number(data.secondPrice),
      secondPriceTime: dateSelected,
      isBusy: data.isBusy ?? false,
      rowId: Number(data.rowId) || 0,
      areaId: data.areaId ? Number(data.areaId) : null,
      updateAll,
    };

    try {
      const response = await axiosInstance.post(ApiConstants.umb.update, params);
      setUpdateAll(false);

      if (response.status === 200) {
        toast.success(i18n.t('umb.umbUpdatedSuccessfully'));
        props.onSubmitData();
        return;
      }

      toast.error(i18n.t('umb.errorUpdatingUmb'));
    } catch (error) {
      toast.error(i18n.t('umb.errorUpdatingUmb'));
    }
  };

  useEffect(() => {
    if (createOrUpdate) {
      handleSubmit(onSubmit)();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createOrUpdate]);

  function handleDateChange(ev: any) {
    if (!ev.target['validity'].valid) return;
    const dt = ev.target['value'] + ':00Z';
    setDateSelected(dt);
  }

  return (
    <div className="umbiForm">
      <div className="umbiTop">
        <GeneralSelect
          preSelectedVal={i18n.t('area.chooseArea')}
          setSelectedVal={() => {}}
          data={areas}
          required={false}
          errors={errors}
          control={control}
          label={i18n.t('area.area')}
          name="areaId"
          value="name"
        />
        <GeneralSelect
          preSelectedVal={i18n.t('umb.chooseRow')}
          setSelectedVal={() => {}}
          data={rows}
          required={false}
          errors={errors}
          control={control}
          label={i18n.t('umb.row')}
          name="rowId"
          value="name"
        />
      </div>

      {/* Two items per row grid */}
      <div className="umbiGrid">
        <div className="umbiField">
          <GeneralInput
            required
            label={i18n.t('umb.code')}
            name="code"
            type="text"
            placeholder={i18n.t('umb.code')}
            errors={errors}
            control={control}
          />
        </div>

        <div className="umbiField">
          <GeneralInput
            required
            label={i18n.t('umb.name')}
            name="name"
            type="text"
            placeholder={i18n.t('umb.name')}
            errors={errors}
            control={control}
          />
        </div>

        <div className="umbiField">
          <GeneralInput
            label={i18n.t('umb.firstPrice')}
            name="firstPrice"
            type="number"
            placeholder={i18n.t('umb.firstPrice')}
            errors={errors}
            control={control}
          />
        </div>

        <div className="umbiField">
          <GeneralInput
            label={i18n.t('umb.secondPrice')}
            name="secondPrice"
            type="number"
            placeholder={i18n.t('umb.secondPrice')}
            errors={errors}
            control={control}
          />
        </div>

        {/* Date */}
        <div className="umbiField">
          <label className="umbiLabel">{i18n.t('umb.dateTime')}</label>
          <input
            type="datetime-local"
            className="umbiDateTime"
            value={(dateSelected || '').toString().substring(0, 16)}
            onChange={handleDateChange}
          />
        </div>

        {/* Checkbox */}
        <div className="umbiField umbiCheckWrap">
          <GeneralInput
            label={i18n.t('umb.occupied')}
            name="isBusy"
            type="checkbox"
            placeholder={i18n.t('umb.occupied')}
            errors={errors}
            control={control}
          />
        </div>
      </div>

      <hr className="umbiDivider" />
    </div>
  );
};

export default UmbsInventory;
